import type { IPartners } from '../partners/partners.types'

export namespace IUsers {
  export namespace Enum {
    export enum Role {
      Owner = 'owner',
      Admin = 'admin',
      User = 'user',
    }
  }

  export type Role = `${IUsers.Enum.Role}`

  export type AdminRole = 'admin' | 'owner'

  export interface BaseModel<R extends IUsers.Role> {
    _id: string
    name: string
    email: string
    role: IUsers.Role
    partner: IPartners.Model<R>
    createdAt: Date
    updatedAt: Date
  }

  export interface AdminModel<R extends IUsers.Role> extends BaseModel<R> {
    registerToken?: string | null
  }

  export type Model<R extends IUsers.Role> = R extends IUsers.AdminRole
    ? AdminModel<R>
    : BaseModel<R>
}
